import { render, staticRenderFns } from "./VxPhoneInput.vue?vue&type=template&id=98b37316"
import script from "./VxPhoneInput.vue?vue&type=script&lang=js"
export * from "./VxPhoneInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports